import { render } from "./Introduce.vue?vue&type=template&id=0e0cfe7c&scoped=true"
import script from "./Introduce.vue?vue&type=script&lang=js"
export * from "./Introduce.vue?vue&type=script&lang=js"

import "./Introduce.vue?vue&type=style&index=0&id=0e0cfe7c&scoped=true&lang=css"

import exportComponent from "D:\\wjm\\offical-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0cfe7c"]])

export default __exports__